<template>
	<div class="input-container">
		<div class="input-title">Validation</div>
		<div class="input-box">
			<selectize v-model="value.custom_validation" :settings="{ create: true }" placeholder="Select Validations" multiple>
				<option value="required">Required</option>
			</selectize>
		</div>
	</div>
</template>

<script>

export default {

	props: ['value'],

};

</script>
